import account from './account.lib.m';

const moveToLoginPage = ({ returnUrl, queryString, message } = {}) => {
  setTimeout(() => {
    if (!message || window.confirm(message)) {
      account.moveToLoginPage(returnUrl, queryString);
    }
  }, 400);
};

export default {
  isLoggedIn: Ridi.globals.isLoggedIn,
  showLogin(returnUrl = window.location.href, queryString) {
    if (Ridi.globals.isLoggedIn) {
      if (returnUrl !== undefined) {
        window.location.href = returnUrl;
      }
      return false;
    }
    moveToLoginPage({
      returnUrl,
      queryString,
      message: '로그인 상태에서 가능합니다. 로그인 페이지로 이동합니다.',
    });
    return true;
  },
  validateIsLoggedIn(returnUrl = window.location.href, queryString) {
    if (!Ridi.globals.isLoggedIn) {
      moveToLoginPage({
        returnUrl,
        queryString,
      });
      return false;
    }
    return true;
  },
};



// WEBPACK FOOTER //
// ./common/account.loginHelper.js